import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
})
export class DialogHeaderComponent {
  private _denominazione: string = '';
  private _praticaCode: string = '';

  @Input()
  set denominazione(value: string | undefined) {
    this._denominazione = value || '';
  }
  get denominazione(): string | undefined {
    return this._denominazione || undefined;
  }

  @Input()
  set praticaCode(value: string | undefined) {
    this._praticaCode = value || '';
  }
  get praticaCode(): string | undefined {
    return this._praticaCode || undefined;
  }
}
